import Swiper from "swiper";
import { Navigation, EffectFade, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

export default function initHomeBanner() {
  const homeBanners = document.querySelectorAll(".home-banner");

  if (!homeBanners.length) return;

  homeBanners.forEach((homeBanner) => {
    const swiperContainer = homeBanner.querySelector(".swiper");
    const progressBar = homeBanner.querySelector(".carousel-progress-bar");
    const nextButton = homeBanner.querySelector(".carousel-button-next");
    const prevButton = homeBanner.querySelector(".carousel-button-prev");

    if (!swiperContainer || !progressBar) return;

    function updateProgressBar(swiperInstance) {
      const progress = ((swiperInstance.realIndex + 1) / swiperInstance.slides.length) * 100;
      progressBar.style.width = `${progress}%`;
    }

    new Swiper(swiperContainer, {
      modules: [Navigation, EffectFade, Autoplay],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoHeight: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      on: {
        init: function () {
          updateProgressBar(this);
        },
        slideChange: function () {
          updateProgressBar(this);
        },
      },
    });
  });
}
